import { string, bool, object, number, oneOf } from 'prop-types'
import Conditional from '../../../Conditional'
import Loader from '../../../Loader'
import { kuiperClassNames, renderIcon } from '../../../utils'
import './styles.scss'

const renderLeftIcon = (icon, iconOptions) => {
  if (icon) {
    return renderIcon(icon, { ...iconOptions, ariaMode: 'hidden' })
  }

  return null
}

const interpolatedValue = (value, extraText, truncateValueAt) => {
  if (value) {
    const interpolatedText = `${extraText.before}${value}${extraText.after}`
    if (truncateValueAt && interpolatedText.length > truncateValueAt) {
      return `${interpolatedText.slice(0, truncateValueAt)}...`
    }
    return interpolatedText
  }

  return null
}

const SelectTrigger = ({
  ariaLabel,
  arrowIcon,
  disabled,
  extraText = { before: '', after: '' },
  hideText,
  icon,
  iconOptions,
  isLoading,
  open,
  placeholder,
  role = 'listbox',
  theme,
  truncateValueAt,
  value,
}) => (
  <div
    role={role}
    aria-expanded={open}
    className={kuiperClassNames('select-trigger', theme, {
      open,
      disabled,
      'integration-icon': icon === 'integration',
    })}
    tabIndex={disabled ? -1 : 0}
    aria-label={ariaLabel}
    aria-busy={!isLoading}
  >
    <Loader dotSize="small" loaded={!isLoading} theme="n8" />
    {renderLeftIcon(icon, iconOptions)}
    <Conditional condition={!hideText}>
      <span>
        {interpolatedValue(value, extraText, truncateValueAt) || placeholder}
      </span>
    </Conditional>
    {renderIcon(arrowIcon, { height: 12, width: 7, ariaMode: 'hidden' })}
  </div>
)
SelectTrigger.displayName = 'Kuiper: SelectTrigger ← Select ← Inputs'

SelectTrigger.propTypes = {
  ariaLabel: string,
  arrowIcon: string,
  disabled: bool,
  extraText: object,
  hideText: bool,
  icon: string,
  iconOptions: object,
  isLoading: bool,
  open: bool,
  placeholder: string,
  role: oneOf(['combobox', 'listbox']),
  theme: string,
  truncateValueAt: number,
  value: string,
}

export default SelectTrigger
